<template>
  <div class="content content-narrow plant-detail">
    <div class="col-12 gt-details">
      <div class="block">
        <div v-if="showLoader" class="overlay"></div>
        <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#D2695C" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-danger">
            <h3 class="block-title text-white"><i class="fa fa-box-open text-white"></i> Package Details</h3>
          <div class="blok-title text-white text-right">
            <router-link to="/packages" title="Go back" class="js-tooltip-enabled text-white">
              <i class="fa fa-angle-double-left text-white"></i> Back
            </router-link>
          </div>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.Id }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Label</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.Label }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Type</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.PackageType) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Harvest Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.SourceHarvestNames) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Quantity</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.Quantity }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Unit Of Measure Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.UnitOfMeasureName }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Unit Of Measure Abbreviation</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.UnitOfMeasureAbbreviation }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Patient License Number</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.PatientLicenseNumber) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Product Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ProductId) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Product Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ProductName) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Product Category Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ProductCategoryName) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Packed Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.PackagedDate) }}</div>
            <div class="col-12 border-top"></div> 
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Initial Lab Testing State</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.InitialLabTestingState) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Lab Testing State</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.LabTestingState) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Lab Testing State Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.LabTestingStateDate) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is Production Batch</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.IsProductionBatch }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Production Batch Number</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ProductionBatchNumber) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is Testing Sample</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.IsTestingSample }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is Process Validation Testing Sample</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.IsProcessValidationTestingSample }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Product Requires Remediation</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.ProductRequiresRemediation }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Contains Remediated Product</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.ContainsRemediatedProduct }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Remediation Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.RemediationDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Received From Manifest Number</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ReceivedFromManifestNumber) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Received From Facility License Number</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ReceivedFromFacilityLicenseNumber) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Received From Facility Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.ReceivedFromManifestNumber) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Received Date Time</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.ReceivedDateTime) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is On Hold</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ pack.IsOnHold }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Archived Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.ArchivedDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Finished Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.FinishedDate) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Last Modified</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(pack.LastModified) }}</div>
          </div>
        </div>
        <div class="block-header bg-danger">
          <h3 class="block-title text-white"><i class="fa fa-door-open"></i> Assigned Room</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.RoomId)  }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(pack.RoomName) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { helper } from '@/helper.js';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

export default {
  name: 'PackageDetails',
  data() {
    return {
      pack: {
        Id: 0,
        Label: '',
        PackageType: '',
        SourceHarvestNames: '',
        Quantity: 0,
        UnitOfMeasureName: '',
        UnitOfMeasureAbbreviation: '',
        PatientLicenseNumber: null,
        ProductId: 0,
        ProductName: '',
        ProductCategoryName: '',
        PackagedDate: '',
        InitialLabTestingState: '',
        LabTestingState: '',
        LabTestingStateDate: null,
        IsProductionBatch: false,
        ProductionBatchNumber: '',
        IsTestingSample: '',
        IsProcessValidationTestingSample: '',
        ProductRequiresRemediation: '',
        ContainsRemediatedProduct: '',
        RemediationDate: null,
        ReceivedFromManifestNumber: '',
        ReceivedFromFacilityLicenseNumber: '',
        ReceivedFromFacilityName: '',
        ReceivedDateTime: null,
        IsOnHold: false,
        ArchivedDate: null,
        FinishedDate: null,
        LastModified: null,
        RoomId: 0,
        RoomName: ''
      },
      showLoader: false
    };
  },
  mounted() {
    let vm = this;
    vm.showLoader = true;
    helper.sendPostRequest('/packages/get', { id: vm.$route.params.id})
      .then((data) => {
        vm.showLoader = false;
        if (data.status === 'success') {
          vm.pack = data.data;
        } else {
          vm.$router.push('/packages');
        }
      });
  },
  components: {
    HashLoader
  },
  methods: {
    getDate(dateText) {
      if (dateText === '') {
        return 'null';
      }
      let date = new Date(dateText).toISOString().substr(0, 19).replace('T', ' ');
      return date;
    },
    getValue(value) {
      if (!value) {
        return 'null';
      }
      return value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/PackageDetails.vue